export default {
  code: 
`
// 今天心情好
// 我给你表演写代码
// 我要开始写啦
const { 😆, 🤗 } = 🌎;
😆.say('我要结婚了,速来吃席!❤️');
🤗.response('好的，我一定到场🍉！');
Utils.meeting(😆,🤗);
Utils.generateInvitation(😆,🤗);
// 好了我写完了
// 我要开始运行啦`,
  executions: [{
    name:'初始化',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'解压中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'组装中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'打包中',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'微笑🙂',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'大笑😄',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'编译中...',
    time: '',
    visible: false
  }],
  barrages: [
    '66666666',
    '愿你美梦成真',
    '你的邀请函真是不错',
    '人美心更美',
    '你是最棒的',
    '哇哇哇',
    '你写代码老快了',
    '你的代码真是棒',
    '😗 😙 😚 😋 ',
    '只要代码写得好，老婆永远跑不了',
    '新婚快乐！早生贵子！',
    '百年好合，永结同心！',
    '祝你们幸福美满，白头偕老！',
    '郎才女貌，天生一对！',
    '一定要幸福哦！❤️',
    '新婚大喜，花好月圆！',
    '甜甜蜜蜜，长长久久！',
    '祝你们携手共度美好人生！',
    '满满的祝福送给你们！',
    '恭喜恭喜！🎉🎉🎉',
    '愿你们的爱情像代码一样完美',
    'Bug全消灭，幸福全输出！',
    '永远幸福，永远热恋！',
    '民政局扛把子发来贺电',
    '一定要请我吃喜糖啊！🍬',
    '世界上最幸福的新人！',
    '祝福你们！祝福你们！',
    '恭喜恭喜，大吉大利！',
    '新婚快乐，百年好合！',
    '愿你们恩爱如初，白头到老！'
  ],
}